var firebaseConfig = {
    apiKey: "AIzaSyB2hiPhbXvkHQcZgpQWtvHslDHtv_QucGo",
    authDomain: "quelpersonnagees-tu.firebaseapp.com",
    databaseURL: "https://quelpersonnagees-tu.firebaseio.com",
    projectId: "quelpersonnagees-tu",
    storageBucket: "quelpersonnagees-tu.appspot.com",
    messagingSenderId: "991717380613",
    appId: "1:991717380613:web:91c26576623aa8246b426c",
    measurementId: "G-HHV9TSPDS6"
  };

  export default firebaseConfig